import React from "react";
import a from "../../assets/OfferingB/ai_features1.svg";
import b from "../../assets/OfferingB/ai_features2.svg";
import c from "../../assets/OfferingB/ai_features3.svg";


const background = "https://storage.googleapis.com/think41-web-new/assets/Common/background_01.svg"
const framer = "https://storage.googleapis.com/think41-web-new/assets/OfferingB/build_ai.svg"

const features = [
  {
    icon: a,
    text: "Add AI-driven functionality to core platforms",
    description:
      "Enhance existing software platforms with AI features like predictive analytics, automation, and personalization to improve efficiency and user satisfaction.",
  },
  {
    icon: c,
    text: "Integrate GenAI into product roadmaps",
    description:
      "Strategically plan and phase generative AI adoption, ensuring alignment with business goals and seamless integration into upcoming product releases.",
  },
  {
    icon: b,
    text: "Build intelligence into UX, backend, and operations",
    description:
      "Embed AI in user interfaces, backend systems, and operational workflows to deliver smarter, adaptive, and more efficient digital experiences.",
  },
];

const BuildFeatures = () => {
  return (
    <section
      className="
        w-full
        bg-no-repeat
        bg-cover
        text-white
      "
       style={{
              backgroundImage: `url(${background})`,
            }}

    >
      {/* ——— Mobile Only Layout ——— */}
      <div className="md:hidden flex flex-col items-center px-5 py-10">
        {/* 1. Heading */}
        <h2 className="text-[24px] font-bold mb-4 font-montserrat w-full">
          Build AI Features
        </h2>

        {/* 2. Paragraph */}
        <p className="font-light w-full md:max-w-[300px] mb-8 font-roboto">
          Embed AI capabilities into new or existing products to deliver smarter
          features and intelligent user experiences.
        </p>

        {/* 3. Framer Image */}
        <div className="w-full flex justify-center mb-8">
          <img
            src={framer}
            alt="Framer preview"
            className="w-[80%] max-w-[350px]"
          />
        </div>

        <div className="flex flex-col gap-4 w-full font-roboto">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-white rounded-md shadow overflow-hidden text-[#2D3139] px-[20px] py-[16px] font-[16px] h-[80px] flex items-center w-full"
            >
              <p>{feature.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ——— Desktop / Tablet Layout ——— */}
      <div className="hidden md:flex items-center justify-center h-[800px]">
        <div className="flex justify-between items-center w-full max-w-[1200px] ">
          {/* Left Side */}
          <div className="flex w-full items-end">
            <div>
              <div>
                <div className="text-[40px] md:text-[40px] text-white font-bold w-2/3 font-montserrat">
                  Build AI Features
                </div>
                <p className="w-2/3  mt-2  font-roboto text-[16px] font-[400]">
                  Embed AI capabilities into new or existing products to deliver
                  smarter features and intelligent user experiences.
                </p>
              </div>
              <div className="flex flex-col gap-[30px] mt-[40px]">
                {features.map((feature, index) => (
                  <div
                    className="w-[654px] h-[124px] shrink-0 bg-white flex flex-col justify-between p-[20px] gap-2"
                    key={index}
                  >
                    <div className="flex gap-[18px]">
                      <img
                        src={feature.icon}
                        alt=""
                        className="w-[30px] h-[30px]"
                      />
                      <h3 className="text-[#2D3139] font-roboto text-2xl font-medium leading-[28.11px]">
                        {feature.text}
                      </h3>
                    </div>
                    <p className="text-[#2D3139] font-roboto text-base font-light leading-6">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img src={framer} alt="" />
            </div>
          </div>

          {/* Right Side */}
        </div>
      </div>
    </section>
  );
};

export default BuildFeatures;